import { render } from "./Number.vue?vue&type=template&id=0680432f"
import script from "./Number.vue?vue&type=script&setup=true&lang=js"
export * from "./Number.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/TableFields/Number.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0680432f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0680432f', __exports__)) {
    api.reload('0680432f', __exports__)
  }
  
  module.hot.accept("./Number.vue?vue&type=template&id=0680432f", () => {
    api.rerender('0680432f', render)
  })

}


export default __exports__